<template lang="pug">
    div(:style="page === 'not set' ? 'width:230px;' : 'width:50px;'" class="add-watchlist"
        style="border:1px solid #144b4d; border-radius: 6px;background: none; display: flex; justify-content: space-between")
        v-btn( v-if="page === 'not set'" class="" small
                :disabled="disabled"
                style="background-color: transparent; text-align: left; box-shadow: none; height: 30px; text-transform: lowercase; font-size: 12px; font-weight: 400;")
            span(class="ellipsis" v-if="selectedWatchlists.length == 1") {{latestWatchlist}}
            span(class="ellipsis" v-else-if="selectedWatchlists.length > 1")
                span {{currentWatchlistName}},
                span(v-if="selectedWatchlists.length > 1" class="pr-2") +{{selectedWatchlists.length-1}}
            span(class="ellipsis" v-else) {{this.$t('add_to')}}
                b(class="") {{currentWatchlistName}}

        v-btn( v-else-if="page === 'home'" class="white--text" x-small
                :disabled="disabled"
                style="text-transform:none; width:30px; height:18px; background-color: rgba(20, 75, 77, .5); box-shadow:none; border-radius:4px 0 0 4px")

        v-menu( offset-y bottom left origin="top right" open-on-hover
                    :close-on-content-click="false"
                    transition="scroll-y-transition")
            template( v-slot:activator="{ on, attrs }")
                v-btn( v-if="page === 'not set'" blue
                        v-bind="attrs"
                        v-on="on"
                        class="" style="height:30px; width:20px;box-shadow: none; border-left:1px solid #144b4d; border-radius:0 6px 6px 0"
                        :disabled="disabled")
                    v-icon mdi-chevron-down

                v-btn( v-else-if="page === 'home'" blue
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        class="white--text" style="position:relative; height:18px; width:20px;box-shadow: none; background-color:rgba(20, 75, 77, .5); border-left:1px solid rgba(255,255,255,.5); border-radius:0 4px 4px 0"
                        :disabled="disabled")
                    v-icon(size="17" style="position:absolute; left:-40px; width:30px; border:0px solid black;") mdi-eye-outline
                    v-icon(size="18" style="position:absolute; left:-10px; border:0px solid black;") mdi-chevron-down
            v-list( style="width:265px")
                v-list-item( v-for="watchlist in watchlists"
                    class="cursor-pointer v-list-item--link v-list-sub-item"
                    style="height:10px; ")
                    v-list-item-title {{ watchlist.name }}

                    div(style="position:relative;")
                        v-checkbox(v-model="selectedWatchlists" :value="watchlist.watchlist_id" color="#244360")
                        div(v-if="user.user_id === 0" @click="preCheckAddToWatchlists()" style="position:absolute; top:21px; left:1px; width:22px; height:22px; border:0px solid;")
                v-divider(style="margin-bottom:62px;display: none")
            div(style="background:white;display:flex; justify-content: flex-end; padding: 0 12px 12px")
                v-btn(v-if="!createNew"
                      style="" outlined small class="btn-secondary -lighten-3"
                      @click="openCreateWatchlist()") {{ $t('new_watchlist') }}

                v-text-field( v-if="createNew"
                        v-model="newWatchlistName"
                        label="" placeholder="New Watchlist Name" outlined dense hide-details="true"
                        @keyup.enter="createNewWatchlist(newWatchlistName, stocks)"
                        style="width: 100px; font-size: 12px; height:28px")

                v-btn(@click="addToWatchlists(stocks)"
                       style="" outlined small
                       class="btn-primary ml-3") {{ $t('done') }}
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import ApiStocks from "../Services/ApiStocks";

    export default {
        name: 'WatchlistAddTo',
        props: {
            stocks: Array,
            disabled: Boolean,
            page: {
                type: String,
                default: 'not set'
            }
        },
        data: function() {
            return {
                newWatchlistName: "",
                createNew: false,
                oldSelectedWatchlists: [],
                selectedWatchlists: [],
                latestWatchlist: ""
            }
        },
        methods: {
            ...mapActions([
                "addStocksToWLJ",
                "removeStocksFromWLJ",
                "removeStocksFromWLI",
                "loadUserWatchLists",
                "loadUserWatchListItems",
                "loadUserWatchlistJoins"
            ]),
            ...mapMutations([
                "setRegisterType",
                "setRegisterWindows"
            ]),
            openCreateWatchlist() {
                // Open register popup if visitor
                if(this.user.user_id === 0) {
                    this.setRegisterType('signup');
                    this.setRegisterWindows(true);

                    return;
                }

                this.createNew = true;
            },
            createNewWatchlist(name, stocks) {
                if (name==="") {
                    this.newWatchlistName = "";
                    this.createNew = false;
                    return;
                }

                const that = this;

                ApiStocks.insertWatchlist({name: name, user_id: this.user.user_id}).then((res) => {
                    let watchlist = res.data;
                    that.$store.commit('addWatchlist' , watchlist );
                    that.selectedWatchlists.push(watchlist.watchlist_id);
                    that.addToWatchlists(stocks);
                });
                this.newWatchlistName = "";
                this.createNew = false;
            },
            preCheckAddToWatchlists() {
                // Open register popup if visitor
                if(this.user.user_id === 0) {
                    this.setRegisterType('signup');
                    this.setRegisterWindows(true);

                    return;
                }
            },
            async addToWatchlists(stocks) {
                const oldSelectedWatchlistsString = JSON.stringify(this.oldSelectedWatchlists.sort((a, b) => a - b));
                const selectedWatchlistsString = JSON.stringify(this.selectedWatchlists.sort((a, b) => a - b));

                console.log(`${oldSelectedWatchlistsString} = ${selectedWatchlistsString}`);

                if(selectedWatchlistsString !== oldSelectedWatchlistsString) {
                    const originalySelectedWatchlists = JSON.parse(JSON.stringify(this.oldSelectedWatchlists));
                    const selectedWatchlistsNew = JSON.parse(JSON.stringify(this.selectedWatchlists));

                    const user_id = this.user.user_id;
                    const stock_id = stocks[0].stock_id;
                    const ticker = stocks[0].ticker;

                    console.log(JSON.parse(JSON.stringify(originalySelectedWatchlists)));
                    console.log(JSON.parse(JSON.stringify(selectedWatchlistsNew)));
                    console.log(JSON.parse(JSON.stringify(this.getWatchlists)));
                    console.log(JSON.parse(JSON.stringify(stocks)));

                    for(const ow of originalySelectedWatchlists) {
                        const watchlist_id = ow;

                        console.log('xxxx');
                        console.log(user_id);
                        console.log(stock_id);
                        console.log(watchlist_id);

                        await this.removeStocksFromWLJ({
                            watchlist_id: watchlist_id,
                            stock_id: stock_id,
                            user_id: user_id
                        });
                    }

                    await this.removeStocksFromWLI({
                        stock_id: stock_id,
                        user_id: user_id
                    });

                    console.log(JSON.parse(JSON.stringify(selectedWatchlistsNew)));

                    for(const sw of selectedWatchlistsNew) {
                        const watchlist_id = sw;
                        console.log(watchlist_id);

                        await this.addStocksToWLJ({
                            watchlist_id: watchlist_id,
                            stock_id: stock_id,
                            user_id: user_id
                        });
                    }

                    await this.loadUserWatchListItems(user_id);
                    await this.loadUserWatchlistJoins(user_id);

                    console.log(JSON.parse(JSON.stringify(selectedWatchlistsNew)));

                    if(selectedWatchlistsNew.length > 0) {
                        this.$store.commit("setMessage", {text: `Added ${ticker} to selected watchlists`, type: 'success'});
                    } else {
                        this.$store.commit("setMessage", {text: `Removed ${ticker} from all watchlists`, type: 'success'});
                    }

                    this.oldSelectedWatchlists = selectedWatchlistsNew;

                    if(this.$parent.$parent.$parent.$parent.$refs.stockCardElement !== undefined) {
                        const components = this.$parent.$parent.$parent.$parent.$refs.stockCardElement;
                        console.log(components);

                        for(const element of components) {
                            const componentStockId = element.stock.stock_id;

                            if(componentStockId === stock_id) {
                                console.log(element.$refs.watchlistAddToElement);

                                element.$refs.watchlistAddToElement.oldSelectedWatchlists = this.oldSelectedWatchlists;
                                element.$refs.watchlistAddToElement.selectedWatchlists = this.selectedWatchlists;
                            }
                        }
                    } else if(this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.stockCardElement !== undefined) {
                        const components = this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.stockCardElement;
                        console.log(components);

                        for(const element of components) {
                            const componentStockId = element.stock.stock_id;

                            if(componentStockId === stock_id) {
                                console.log(element.$refs.watchlistAddToElement);

                                element.$refs.watchlistAddToElement.oldSelectedWatchlists = this.oldSelectedWatchlists;
                                element.$refs.watchlistAddToElement.selectedWatchlists = this.selectedWatchlists;
                            }
                        }
                    }
                } else {
                    this.$store.commit("setMessage", {text: 'Nothing is changed', type: 'error'});
                }
            },
            initSelectedWatchList() {
                let Ids = [];
                Ids = this.getWatchlistJoins.filter(item => item.stock_id == this.stocks[0].stock_id && item.user_id == this.user.user_id).map(item => item.watchlist_id);
                this.selectedWatchlists = [...Ids];
                this.oldSelectedWatchlists = this.selectedWatchlists
            }
        },
        computed: {
            ...mapGetters([
                "getWatchlists",
                "getUserCurrentWatchlistId",
                "getWatchlistItems",
                "getWatchlistJoins"
            ]),
            watchlists() {
                return this.$store.getters["getWatchlists"];
            },
            watchlistIDs: {
                get() {
                },
                set(newVal) {
                }
            },
            currentWatchlist() {
                const watchlistId = this.getUserCurrentWatchlistId;
                return this.getWatchlists.find((item) => item.watchlist_id === watchlistId)
            },
            currentWatchlistName() {
                return this.currentWatchlist.name;
            },
            user() {
                return JSON.parse(localStorage.getItem('user'))
            }
        },
        watch: {
            stocks() {
                this.initSelectedWatchList();
            },
            selectedWatchlists() {
                if (this.selectedWatchlists.length != 0) {
                    this.latestWatchlist = this.getWatchlists.find(item => item.watchlist_id == this.selectedWatchlists[0]).name
                }
            }
        },
        created() {
        },
        mounted() {
            this.initSelectedWatchList();
        },
        beforeDestroy() {
        },
    }
</script>

<style scoped>
.ellipsis {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}

.theme--light.v-btn:before {
    height: 30px;
}

.theme--light.v-btn:hover:before {
    opacity: 0;
}

.stock-card-placeholder .add-watchlist {
    border: 0 !important;
}

>>>.v-text-field {
    height:28px;
    min-height: 28px;
}

>>>.v-text-field--outlined.v-input--dense>.v-input__control>.v-input__slot {
    min-height: 16px;
}
</style>
